import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"

import _ from 'lodash'
import ogImage from "../../images/posts/66/thumb-landscape.jpg"

const Post66 = ({ data: { allCategoryJson, postsJson }, location }) => {

  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>ミュウミュウという名前を聞くと、「若い世代に人気のブランド」というイメージを思い浮かべる方もいらっしゃるかもしれません。</p>
          <p>しかし、実際にバッグを手に取ってみると、その印象は少し変わります。<br></br>
          甘さの奥に感じられるのは、レザーの上質な質感、丁寧な仕立て、そして使い続けるほどに実感する確かな"安心感"です。</p>
          <p>ミュウミュウのバッグにはさまざまなデザインがありますが、中でも象徴的な存在として知られているのが、ワンダーとアイビーの2シリーズです。</p>
          <p>ワンダーの立体的な表情は、可憐でありながら決して軽すぎることはなく、装いにほどよい華やかさと余裕を添えてくれます。</p>
          <p>それに対して、アイビーのミニマルな佇まいは、年齢やトレンドに左右されない静かな魅力を備えており、シーンを選ばず自然に寄り添ってくれます。</p>
          <p>どちらにも共通しているのは、「誰かの年齢に合わせて作られていない」という点です。<br></br>
          だからこそ、20代には"新鮮"に、30代・40代には"しっくり"と感じられます。</p>
          <p>ミュウミュウのバッグは、年齢を重ねたからこそわかるバランス感覚や、「可愛いだけでは物足りない」という感覚にも、きちんと応えてくれる存在です。</p>
          <p>本記事では、そんなミュウミュウを象徴するワンダーとアイビーにフォーカスし、それぞれのデザインの魅力や印象の違い、そしてコーディネートのヒントをご紹介します。</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2 style={{color: "#0a9186"}}>目次</h2>
        <p>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>1 |</span>&nbsp;&nbsp;ミュウミュウって、どんなブランド？</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>2 |</span>&nbsp;&nbsp;ワンダーバッグって何がすごいのか</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec3" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ワンダー（25 × 18 × 7cm）｜トレンド×女性らしさ</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec4" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ワンダー｜What's in my bag?</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec5" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;ワンダー｜コーデ｜肩の力を抜いた春のデニムシック</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec6" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>3 |</span>&nbsp;&nbsp;アイビーって何が魅力なのか</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec7" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;アイビー（20 × 24 × 1cm）｜実用性×タイムレス</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec8" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;アイビー｜What's in my bag?</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec9" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;アイビー｜コーデ｜春の仕事服に、やわらかな品格を</ScrollLink>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec10" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>4 |</span>&nbsp;&nbsp;まとめ：ワンダーVSアイビー、どっちの気分？</ScrollLink>
          </div>
        </p>
      </div>
      <section name="sec1" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/66/1.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>ミュウミュウって、どんなブランド？</h2>
        </div>
        <p>改めて触れておきたいのが、「MIU MIU / ミュウミュウ」というブランドの立ち位置です。</p>
        <p>ミュウミュウは、老舗ラグジュアリーブランドであるプラダの姉妹ブランドとして、1993年に誕生しました。</p>
        <p>いわゆる「セカンドライン」と呼ばれることもありますが、その実態は、もうひとつの価値観を提示するための独立した存在に近いものです。</p>
        <p>デザインを手がけているのは、プラダと同じく「ミウッチャ・プラダ」。<br></br>
        プラダでは知性や構築美を、ミュウミュウでは感情や遊び心を。</p>
        <p>同じデザイナーの手によるブランドでありながら、まったく異なる表情を見せる点が大きな特徴です。</p>
        <p>「ミュウミュウ」というブランド名は、ミウッチャ・プラダの幼少期の愛称に由来しています。その親密で少し無邪気な響きが示す通り、ミュウミュウはラグジュアリーでありながら、どこか肩の力が抜けた存在です。完璧すぎないからこそ、日常にすっとなじみ、持つ人の個性を自然に引き立ててくれる——</p>
        <p>それが、ミュウミュウというブランドの本質だと言えるでしょう。</p>
      </section>
      <section name="sec2" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/66/2.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>ワンダーバッグって何がすごいのか</h2>
        </div>
        <p>ワンダーバッグは、ミュウミュウを象徴する「マテラッセレザー」を用いたバッグシリーズです。<br></br>
        マテラッセとは、フランス語で"詰めもの"を意味する言葉に由来し、レザーにキルティングのような立体感を生み出すクラフト技法のことです。表面にふっくらとした陰影が生まれ、持つだけで自然と視線を引き寄せます。</p>
        <p>特徴的なのは、その立体感が装飾的になりすぎない点です。柔らかなレザーと計算されたフォルムによって、可憐さの中に品の良さが感じられ、日常のスタイリングにも無理なく馴染みます。</p>
        <p>さらに、ミュウミュウはこのマテラッセをシーズンごとに少しずつアップデートしながら提案しており、2023年以降も継続して注目されている定番シリーズです。</p>
        <p>一過性のトレンドにとどまらず、ブランドのアイデンティティとして育てられている点も、支持され続ける理由のひとつと言えるでしょう。</p>
        <div name="sec3" className="mt8">
          <div className="img-three-cloumn mt8">
            <figure className="img-small">
              <StaticImage src="../../images/posts/66/3.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/66/4.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/66/5.jpg" alt=""/>
            </figure>
          </div>
          <span className="text-center">MIU MIU / ワンダー マテラッセ レザー ホーボー / 25 × 18 × 7cm</span>
          <div className="mt4">
            <h3>◆ ワンダー（25 × 18 × 7cm）｜トレンド×女性らしさ</h3>
            <p>立体的に施されたマテラッセレザーは、やわらかな表情を生み出しながらも、装い全体に上質な存在感を添えてくれます。ブランドを象徴するこのキルティングは、光の当たり方によって陰影が生まれ、シンプルなコーディネートでも自然と華やかさを演出します。</p>
            <p>また、短めのハンドルが生み出す脇に収まるバランスは、持つだけでスタイリングに今らしい抜け感をプラスしています。</p>
            <p>付属のストラップを使用すればショルダーバッグとしても楽しめ、シーンや装いに合わせたアレンジが可能です。</p>
          </div>
        </div>
        <div name="sec4" className="mt8">
          <figure>
            <StaticImage src="../../images/posts/66/6.jpg" alt=""/>
          </figure>
          <div className="mt4">
            <h3>◆ ワンダー｜What's in my bag?</h3>
            <p>ワンダー マテラッセ レザー ホーボー（25 × 18 × 7cm）は、日常に必要なアイテムを無理なく収められる、実用性の高いサイズ感が魅力です。</p>
            <p>スマートフォンやミニウォレット、リップやイヤホン、サングラス、ハンカチなど、外出時の必需品をすっきり収納できます。</p>
            <p>コンパクトな見た目ながら収納力があり、バッグの中身が自然と整うため、ショッピングからカフェタイムまで幅広いシーンに対応します。</p>
          </div>
        </div>
        <div name="sec5" className="mt8">
          <figure>
            <StaticImage src="../../images/posts/66/7.jpg" alt=""/>
          </figure>
          <div className="mt4">
            <h3>◆ ワンダー｜コーデ｜肩の力を抜いた春のデニムシック</h3>
            <p>デニムシャツとワイドデニムを合わせたリラックス感のあるカジュアルスタイルに、丸みのあるフォルムが特徴のワンダーを合わせることで、程よい女性らしさとトレンド感をプラスしました。</p>
            <p>立体的なマテラッセレザーがコーディネートのアクセントとなり、シンプルなデニムスタイルでもラフになりすぎず、洗練された印象に仕上がります。</p>
            <p>休日のショッピングやカフェ巡りなど、アクティブに過ごすシーンに自然と馴染むコーディネートです。</p>
          </div>
        </div>
      </section>
      <section name="sec6" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/66/8.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>アイビーって何が魅力なのか</h2>
        </div>
        <p>アイビーは、ミュウミュウのバッグラインの中でも、装飾を極力そぎ落としたミニマルな美しさが際立つシリーズです。</p>
        <p>ワンダーが立体感や陰影で魅せるのに対し、アイビーはあくまでフラットで端正なフォルムを貫いています。レザーそのものの質感、縁の処理、シルエットの精度。細部に目を向けるほど、仕立ての良さが伝わってくるデザインです。</p>
        <p>主張を抑えながらも、決して無難には見えない点も特徴です。<br></br>
        直線的でシャープな印象の中に、ミュウミュウらしい柔らかさと女性らしさが、ほんのりと残されています。</p>
        <p>この「引き算の美学」こそが、アイビー最大の魅力。<br></br>
        流行を強く打ち出すのではなく、装い全体の完成度を静かに引き上げる存在として、持つ人のスタイルやシーンに自然に寄り添います。</p>
        <p>また、シーズンに左右されにくく、長く使い続けられる点もアイビーの強みです。<br></br>
        トレンドが移り変わっても古く感じにくく、「気づけばいつも手に取っている」——<br></br>
        そんな存在になり得るバッグです。</p>
        <div name="sec7" className="mt8">
          <div className="img-three-cloumn mt8">
            <figure className="img-small">
              <StaticImage src="../../images/posts/66/9.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/66/10.jpg" alt=""/>
            </figure>
            <figure className="img-small">
              <StaticImage src="../../images/posts/66/11.jpg" alt=""/>
            </figure>
          </div>
          <span className="text-center">MIU MIU / アイビー レザーバッグ / 20 × 24 × 1cm</span>
          <div className="mt4">
          <h3>◆ アイビー（20 × 24 × 1cm）｜実用性×タイムレス</h3>
            <p>アイビー レザーバッグは、無駄をそぎ落としたフォルムが印象的なシリーズです。<br></br>
            ミュウミュウの「可愛い」に寄りすぎず、モードと洗練の共存を求める方にしっくりと馴染みます。</p>
            <p>コンパクトながらも必要な持ち物をすっきりと収められる設計で、日常使いに取り入れやすい実用性も兼ね備えています。取り外し可能なショルダーストラップにより、ハンドバッグとショルダーの2WAYで使用できる点も魅力です。シーンや装いに合わせて持ち方を変えられるため、オン・オフを問わず活躍します。</p>
            <p>トレンドを主張するバッグではなく、長く寄り添う"定番"として持てる存在です。</p>
          </div>
        </div>
        <div name="sec8" className="mt8">
          <figure>
            <StaticImage src="../../images/posts/66/12.jpg" alt=""/>
          </figure>
          <div className="mt4">
          <h3>◆ アイビー｜What's in my bag?</h3>
            <p>アイビー（20 × 24 × 1cm）は、縦長フォルムが特徴のすっきりとしたデザインながら、日常に必要なアイテムを無理なく収められる実用的なサイズ感が魅力です。</p>
            <p>スマートフォンやミニウォレット、リップ、イヤホン、ハンカチ、鍵など、外出時の必需品がコンパクトにまとまり、バッグの中でも美しく整理できます。</p>
            <p>ミニマルでありながら存在感のある佇まいは、「必要なものを心地よく持ち歩く」という現代的なスタイルにぴったりのバッグといえます。</p>
          </div>
        </div>
        <div name="sec9" className="mt8">
          <figure>
            <StaticImage src="../../images/posts/66/13.jpg" alt=""/>
          </figure>
          <div className="mt4">
            <h3>◆ アイビー｜コーデ｜春の仕事服に、やわらかな品格を</h3>
            <p>ジャケットとワンピースを組み合わせた上品な装いに、直線的でミニマルなデザインのアイビーを合わせることで、知的で落ち着いた印象を演出しました。</p>
            <p>縦長のすっきりとしたシルエットが全体を引き締め、ビジネスシーンにもふさわしい端正なスタイルを完成させます。</p>
            <p>通勤や打ち合わせはもちろん、会食やフォーマルな場面にも対応できる、洗練されたきれいめコーディネートです。</p>
          </div>
        </div>
      </section>
      <section name="sec10" className="section-content">
        <figure>
          <StaticImage src="../../images/posts/66/14.jpg" alt=""/>
        </figure>
        <div className="mt8">
          <h2>まとめ：ワンダーVSアイビー、どっちの気分？</h2>
          <p className="mt4">― ライフスタイルで考える、ミュウミュウという選択 ―</p>
        </div>
        <p>バッグ選びに明確な正解はありません。<br></br>
        だからこそ大切なのは、「今の自分がどんな気分で過ごしたいか」という視点です。</p>
        <p>アクティブに過ごす日常や、肩の力を抜いたおしゃれを楽しみたい方には「ワンダー」がおすすめです。立体感のあるレザーが、カジュアルスタイルを自然に整え、装いにやわらかな品格と余裕を添えてくれます。</p>
        <p>一方、仕事の日やきちんとした場面でも自分らしさを大切にしたい方には「アイビー」がおすすめです。シンプルで洗練されたデザインが、装いをさりげなく格上げしてくれます。</p>
        <p>トレンドや年齢で選ぶのではなく、 "今の自分のライフスタイルに寄り添うかどうか"。</p>
        <p>ミュウミュウのバッグは、その瞬間の気分や生き方に自然とフィットし、長く愛用できる存在です。</p>
        <p>この春、自分らしいスタイルを完成させる一つを選んでみてはいかがでしょうか。</p>
        <p className="mt4"><span className="text-border-bottom">MIU MIU / ミュウミュウのバッグはどこで借りられる？</span></p>
        <p>価格が高く、簡単には手に取りにくいミュウミュウのバッグ。<br></br>
        「試してみたいけれど、買うには勇気がいる」——そんな方も多いのではないでしょうか。</p>
        <p>また、「近くに取り扱い店舗がない」「デパートやブティックは少し緊張してしまう」「実際に自分の服や生活に合うか分からない」といった理由から、気になりつつも一歩踏み出せない方も少なくありません。</p>
        <p>そんな方におすすめなのが、ブランドバッグシェアリングサービス「ラクサス」です。<br></br>
        アプリで簡単に注文でき、自宅にいながら憧れのミュウミュウのバッグを実際に使って体験できます。</p>
        <div className="border"></div>
        <p>📱憧れを日常に──ラクサスでミュウミュウを体験しよう！</p>
        <Link to="https://laxus.co/app/pc/bags/miumiu" className="view-all-button">ミュウミュウのバッグはこちら</Link>
      </section>
    </section>
    </div>
  </div>
</Layout>
)}

export default Post66

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 66}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`